module.exports = __webpack_public_path__ + "static/RingSavvyTagline-WhiteGreen-9f41bbca8d16272c0f5df4ecb3c53db0.svg";